var render = function render(){var _vm=this,_c=_vm._self._c;return _c('school-page',{attrs:{"banner-title":"вечернее обучение в&nbsp;школьном университете","banner-subtitle":"учитесь из&nbsp;любой точки мира онлайн на&nbsp;платформе и&nbsp;получите московский аттестат государственного образца"}})
}
var staticRenderFns = []

export { render, staticRenderFns }